import styled from 'styled-components'

export const StylesAdminInfo = styled.p`
    .value {
        font-weight: bold;
    }
`
